"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageRole = void 0;
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _react = _interopRequireWildcard(require("react"));
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _DmsButtonGroup = require("../../components/DmsButtonGroup/DmsButtonGroup");
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _DmsPermissions = require("../../components/DmsPermissions/DmsPermissions");
var _DmsTable = require("../../components/DmsTable/DmsTable");
var _DmsTableCreateButton = require("../../components/DmsTableButton/DmsTableCreateButton");
var _DmsTableDeleteButton = require("../../components/DmsTableButton/DmsTableDeleteButton");
var _DmsTableEditButton = require("../../components/DmsTableButton/DmsTableEditButton");
var _Permissions = require("../../constants/Permissions");
var _DmsFlexContainer = require("../../components/DmsFlexContainer/DmsFlexContainer");
var _material = require("@mui/material");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsPageRole Component
 * @component
 * @description Represents the page for managing roles within a Document Management System (DMS).
 * @returns {JSX.Element} The JSX element rendering the roles management page.
 */
const DmsPageRole = () => {
  const table = (0, _react.useRef)(null);

  /**
   * Table header configuration for the roles table.
   * @type {Array<Object>}
   */
  const header = [{
    label: _reactIntlUniversal.default.get("Name").d("Name"),
    column_name: "role_name",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Permissions").d("Permissions"),
    column_name: "permissions",
    control: 'select',
    url: "/permission/all",
    properties: {
      label: "permission_name",
      value: "permission_name",
      column_name: "permission_name",
      text_template: '{permission_name}',
      multiple: true,
      filter: {
        value: 'pk',
        field: 'permission_pk',
        join: 'role_permission',
        left: 'role_pk'
      }
    },
    placeholder: "(unchanged)",
    filter: false,
    sortable: false
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    permissions: [_Permissions.Permissions.CAN_EDIT_ROLE],
    column_name: "actions",
    width: "80px",
    sortable: false,
    element: row => {
      const role_name = row.role_name;
      return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
        table: table,
        title: _reactIntlUniversal.default.get("Updaterole_name", {
          role_name
        }).d("Update {role_name}"),
        url: "/role/",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("Deleterole_name", {
          role_name
        }).d("Delete {role_name}"),
        text: _reactIntlUniversal.default.get("DmsPageRole.DeleteButtonMessage", {
          role_name
        }).d("The role {role_name} will be deleted. Are you sure about it?"),
        row_pk: row.pk,
        url: "/role/"
      }));
    }
  }];

  /**
   * Toolbar component for the roles management page.
   * @type {JSX.Element}
   */
  const toolbar = /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: _Permissions.Permissions.CAN_EDIT_ROLE
  }, /*#__PURE__*/_react.default.createElement(_DmsTableCreateButton.DmsTableCreateButton, {
    header: header,
    table: table,
    title: _reactIntlUniversal.default.get("Createrole").d("Create role"),
    url: '/role'
  }))));
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "Roles"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("Roles").d("Roles"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    header: header,
    managed: true,
    needs_authentication: true,
    export_table: false,
    ref: table,
    url: '/role/table',
    toolbar: toolbar
  }))));
};
exports.DmsPageRole = DmsPageRole;